import { render } from "./CourseCreationForm.vue?vue&type=template&id=22de4f50&ts=true"
import script from "./CourseCreationForm.vue?vue&type=script&lang=ts"
export * from "./CourseCreationForm.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__